import IssueDetails from '../Quality/IssueDetails';
import Dependency from '../Quality/Dependency';
import IssueDetailsResolvedReason from '../ResolvedReason';

/**
 * A component that renders the detailed content of a quality issue in a full-page layout.
 */
const QualityIssueDetailContent = () => {
  return (
    <>
      <IssueDetailsResolvedReason />
      <IssueDetails />
      <Dependency />
    </>
  );
};

export default QualityIssueDetailContent;
